import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { searchPA/*, patchByIdPA*/ } from '../../context/users/UserActions'
import { useUserContext } from '../../context/users/UserContext'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { FaRegCopy, FaPlus, FaSearch, FaCalendarAlt, FaSignInAlt } from 'react-icons/fa'
import { Table, Card, Row, Col, Form, Button } from 'react-bootstrap'
import './Sessions.css'

// eslint-disable-next-line
export default function (props) {
  const navigate = useNavigate()
  const { authenticatedUser, setUsers, setActiveSessions, setAlert } = useUserContext()

  const [keywords, setKeywords] = useState('')
  const [allSessions, setAllSessions] = useState([])
  const [filteredSessions, setFilteredSessions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleChangeKeywords = (e) => setKeywords(e.target.value)

  // Función para normalizar texto (quitar acentos)
  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  window.scrollTo({
    top: 0,
    behavior: 'auto',
  })


  // const handleStatus = async (sessionId, status, index) => {
  //   let record = await patchByIdPA({ path: 'sessions',
  //     id: sessionId,
  //     data: {
  //       active: !status
  //     }, 
  //     token: authenticatedUser.value })

  //     if(Object.prototype.hasOwnProperty.call(record, 'sessionId')) {
  //       sessions[index].active = !status
  //       setUsers(sessions)
  //       setAlert({
  //         message: `Sesión ${status ? 'Desactivada' : 'Activada'} exitosamente`,
  //         msgType: 'success'
  //       })
  //     } else {
  //       setAlert({
  //         message: record.message,
  //         msgType: 'warning'
  //       })
  //     }
  // }

  // const handleDelete = async (sessionId) => {
  //   let record = await patchByIdPA({ path: 'sessions',
  //     id: sessionId,
  //     data: {
  //       deleted: true,
  //     }, 
  //     token: authenticatedUser.value })

  //   if(Object.prototype.hasOwnProperty.call(record, 'sessionId')) {
  //     setUsers(sessions.filter((session) => session.sessionId !== sessionId ))
  //     setAlert({
  //       message: `Sesión borrada exitosamente`,
  //       msgType: 'success'
  //     })
  //   } else {
  //     setAlert({
  //       message: record.message,
  //       msgType: 'warning'
  //     })
  //   }
  // }

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const response = await searchPA({ path: 'sessions', keywords, token: authenticatedUser.value })
      if (response.error || !Array.isArray(response.data)) {
        setUsers([])
        setAllSessions([])
        setFilteredSessions([])
        setAlert({
          message: response.message || 'Error en la transacción. Si persiste el error, por favor contacte a soporte.',
          msgType: 'warning'
        })
      } else {
        setUsers(response.data)
        setAllSessions(response.data)
        setFilteredSessions(response.data)
        setActiveSessions(response.activeSession)
      }
    } catch (error) {
      setUsers([])
      setAllSessions([])
      setFilteredSessions([])
      setAlert({
        message: 'Error al cargar las sesiones. Por favor, inténtalo de nuevo.',
        msgType: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }

  // Efecto para filtrar sesiones cuando cambian las keywords
  useEffect(() => {
    if (keywords.trim() === '') {
      setFilteredSessions(allSessions)
    } else {
      const normalizedKeywords = normalizeText(keywords)
      const filtered = allSessions.filter(session =>
        normalizeText(session.sessionName || '').includes(normalizedKeywords) ||
        normalizeText(session.description || '').includes(normalizedKeywords) ||
        normalizeText(session.sessionCode || '').includes(normalizedKeywords)
      )
      setFilteredSessions(filtered)
    }
  }, [keywords, allSessions])

  useEffect(() => {
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSessionStatusPill = (active) => (
    <span
      className={`session-status-pill ${active ? 'session-status-pill--active' : 'session-status-pill--inactive'}`}
    >
      {active ? 'En curso' : 'Finalizado'}
    </span>
  )

  return (
    <div className="sessions-container">
      <div className="container">
        {/* Header Section */}
        <div className="sessions-header">
          <div className="header-content">
            <div className="header-icon">
              <div className="icon-circle">
                <FaPlus className="icon" />
              </div>
            </div>
            <div className="header-text">
              <h1 className="header-title">Sesiones</h1>
              <p className="header-subtitle">Administra y gestiona las sesiones del sistema</p>
            </div>
          </div>
        </div>

        <div className="sessions-plan-notice" role="note">
          <p>
            <strong>Si estás utilizando el Plan de Prueba, podés crear hasta 3 sesiones.</strong>
          </p>
          <p>Luego, podrás actualizar tu plan para seguir disfrutando de todas las funcionalidades.</p>
        </div>

        {/* Actions and Search Section */}
        <Card className="actions-card">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={4} md={12} sm={12} className="mb-3 mb-lg-0">
                <Button
                  variant="primary"
                  className="add-session-btn"
                  onClick={() => navigate('/session')}
                >
                  <FaPlus />
                  Nueva Sesión
                </Button>
              </Col>
              <Col lg={8} md={12} sm={12}>
                <div className="search-input-container">
                  <FaSearch className="search-icon" />
                  <Form.Control
                    type="text"
                    placeholder="Buscar sesiones por nombre, código o descripción..."
                    value={keywords}
                    onChange={handleChangeKeywords}
                    className="search-input"
                  />
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Table Section */}
        <Card className="table-card">
        <Card.Body className="p-0">
          {isLoading ? (
            <div className="loading-state">
              <FaCalendarAlt className="loading-icon" />
              <p className="mt-3">Cargando sesiones...</p>
            </div>
          ) : filteredSessions.length === 0 ? (
            <div className="empty-state">
              <FaCalendarAlt className="empty-icon" />
              <h4>No se encontraron sesiones</h4>
              <p>Intenta con otros términos de búsqueda o agrega una nueva sesión.</p>
            </div>
          ) : (
            <>
              {/* Desktop Table View */}
              <div className="table-responsive d-none d-lg-block">
            <Table className="sessions-table">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Estado</th>
                  <th>Código para invitados</th>
                  <th>Max. invitados</th>
                  <th>Fecha</th>
                  <th>Descripción</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredSessions
                  .sort((a, b) => b.sessionId - a.sessionId)
                  .map((session) => (
                    <tr key={session.sessionId}>
                      <td>#{session.sessionId}</td>
                      <td>
                        {session.active ? (
                          <button 
                            onClick={() => navigate(`/host/sesion/${session.sessionCode}`)}
                            className="session-name-link"
                            title="Ir a la vista del anfitrión"
                          >
                            {session.sessionName}
                          </button>
                        ) : (
                          session.sessionName || '-'
                        )}
                      </td>
                      <td>{getSessionStatusPill(session.active)}</td>
                      <td>
                        {session.active ? (
                          <div className="session-code-container">
                            <span className="session-code">{session.sessionCode}</span>
                            <CopyToClipboard 
                              text={`${window.location.origin}/sesion/${session.sessionCode}`}
                              onCopy={() => setAlert({ 
                                message: `Enlace copiado: ${window.location.origin}/sesion/${session.sessionCode}`, 
                                msgType: 'success' 
                              })}
                            >
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="copy-btn"
                                title="Copiar enlace"
                              >
                                <FaRegCopy />
                              </Button>
                            </CopyToClipboard>
                          </div>
                        ) : (
                          session.sessionCode || '-'
                        )}
                      </td>
                      <td>{session.sessionMax || '-'}</td>
                      <td>{session.sessionDate || '-'}</td>
                      <td>{session.description || '-'}</td>
                      <td>
                        <Button
                          type="button"
                          size="sm"
                          className="session-enter-btn"
                          disabled={!session.active}
                          title={session.active ? 'Ir a la vista del anfitrión' : 'Sesión inactiva'}
                          onClick={() =>
                            session.active && navigate(`/host/sesion/${session.sessionCode}`)
                          }
                        >
                          <FaSignInAlt className="session-enter-btn-icon" aria-hidden />
                          Ingresar a la sesión
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          {/* Tablet Table View - Show only Name, Status, Max Guests, and Date */}
          <div className="table-responsive d-none d-md-block d-lg-none">
            <Table className="sessions-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Estado</th>
                  <th>Max. invitados</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredSessions
                  .sort((a, b) => b.sessionId - a.sessionId)
                  .map((session) => (
                    <tr key={session.sessionId}>
                      <td>
                        {session.active ? (
                          <button 
                            onClick={() => navigate(`/host/sesion/${session.sessionCode}`)}
                            className="session-name-link"
                            title="Ir a la vista del anfitrión"
                          >
                            {session.sessionName}
                          </button>
                        ) : (
                          session.sessionName || '-'
                        )}
                      </td>
                      <td>{getSessionStatusPill(session.active)}</td>
                      <td>{session.sessionMax || '-'}</td>
                      <td>{session.sessionDate || '-'}</td>
                      <td>
                        <Button
                          type="button"
                          size="sm"
                          className="session-enter-btn"
                          disabled={!session.active}
                          title={session.active ? 'Ir a la vista del anfitrión' : 'Sesión inactiva'}
                          onClick={() =>
                            session.active && navigate(`/host/sesion/${session.sessionCode}`)
                          }
                        >
                          <FaSignInAlt className="session-enter-btn-icon" aria-hidden />
                          Ingresar a la sesión
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          {/* Mobile Card View */}
          <div className="sessions-cards d-block d-md-none">
            {filteredSessions
              .sort((a, b) => b.sessionId - a.sessionId)
              .map((session) => (
                <Card key={session.sessionId} className="session-card">
                  <Card.Body className="session-card-body">
                    <div className="session-card-content">
                      <div className="session-info">
                        <div className="session-avatar">
                          <div className="avatar-circle">
                            <span className="avatar-text">#{session.sessionId}</span>
                          </div>
                        </div>
                        <div className="session-details">
                          <div className="session-name">
                            {session.active ? (
                              <a 
                                href={`${window.location.origin}/sesion/${session.sessionCode}`} 
                                target='_blank'
                                rel="noopener noreferrer"
                                className="session-name-link"
                              >
                                {session.sessionName}
                              </a>
                            ) : (
                              session.sessionName || '-'
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="session-status">
                        {getSessionStatusPill(session.active)}
                        {session.active && (
                          <CopyToClipboard 
                            text={`${window.location.origin}/sesion/${session.sessionCode}`}
                            onCopy={() => setAlert({ 
                              message: `Enlace copiado: ${window.location.origin}/sesion/${session.sessionCode}`, 
                              msgType: 'success' 
                            })}
                          >
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              className="copy-btn-mobile"
                              title="Copiar enlace"
                            >
                              <FaRegCopy />
                            </Button>
                          </CopyToClipboard>
                        )}
                      </div>
                    </div>
                    <div className="session-card-actions">
                      <Button
                        type="button"
                        size="sm"
                        className="session-enter-btn session-enter-btn--block"
                        disabled={!session.active}
                        title={session.active ? 'Ir a la vista del anfitrión' : 'Sesión inactiva'}
                        onClick={() =>
                          session.active && navigate(`/host/sesion/${session.sessionCode}`)
                        }
                      >
                        <FaSignInAlt className="session-enter-btn-icon" aria-hidden />
                        Ingresar a la sesión
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))}
          </div>
            </>
          )}
        </Card.Body>
      </Card>
      </div>
    </div>
  )
}

